import React from 'react';
import GalleryContainer from './GalleryContainer/GalleryContainer';

function App() {
  return <GalleryContainer />;
}

export default App;
